<h2
  mat-dialog-title
  mat-dialog-draggable-title
  style="margin-bottom: 0px !important"
>
  {{ "alert.confirm" | translate }}
  <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<div class="row">
  <div
    class="col-2 pr-0"
    style="text-align: center; padding-left: 0px !important; padding-top: 15px"
  >
    <!--<em class="material-icons confirm-ico">
        info
      </em>-->
    <em class="fa fa-warning text-primary large"></em>
  </div>
  <div class="col-10 pl-0">
    <div
      [innerHTML]="message | translate"
      style="
        padding: 5px 7px 15px;
        font-size: medium;
        overflow-wrap: break-word;
      "
    ></div>
  </div>
</div>

<div mat-dialog-actions class="justify-content-center">
  <!--build icon, set default cancel-->
  <button
    class="ml-2"
    mat-raised-button
    color="primary"
    [mat-dialog-close]="true"
  >
    <mat-icon class="mr-0">arrow_back</mat-icon>{{ "button.back" | translate }}
  </button>
</div>
